import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionDetail from "@/pages/SolutionDetail";

export const Route = createFileRoute("/zh-cn/industries/medical-devices/$slug/")({
  head: ({ params }) => buildRouteHead(`/zh-cn/industries/medical-devices/${params.slug}`),
  component: SolutionDetail,
});

